module.exports = __webpack_public_path__ + "fonts/text-medium.ec6f593d.woff";